import React from 'react'
import WhyWileyRow from './WhyWileyRow'

class WhyChooseWileyComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            showContent: false,
            chooseWileyRow: []
        }
    }
    chunkArray(myArray, chunk_size){
        var results = [];
        while (myArray.length) {
            results.push(myArray.splice(0, chunk_size));
        }
        return results;
    }
    componentDidMount(){
        this.props.whyWileyData &&
        this.props.whyWileyData.forEach(whyWileyContent => {
            if(!Array.isArray(whyWileyContent.content)){
                this.setState({
                    [whyWileyContent.acf_fc_layout]: whyWileyContent.content
                })
            }
            else{
                let result=this.chunkArray(whyWileyContent.content, 2)
                this.setState({
                    chooseWileyRow: result
                })
            }
        })
        this.setState({
            showContent: true
        })
    }
    
    render(){
        return(
            <React.Fragment>
            {this.state.showContent?
                <div className="container choose-wiley-container">
                    <div className="row">
                        <div className="col card-heading">
                            <div dangerouslySetInnerHTML={{ __html: this.state.hero_text_block}}/> 
                        </div>
                    </div>
                    {this.state.text_block &&
                    <div className="row">
                        <div className="col card-heading-content" dangerouslySetInnerHTML={{ __html: this.state.text_block}}/>
                    </div>
                    }
                    {this.state.chooseWileyRow.map((chooseRow, index)=>{
                        return <WhyWileyRow rowContent={chooseRow} key={index}/>
                    })}
                </div>:null
            }
           </React.Fragment> 
        )
    }
}
export default WhyChooseWileyComponent